export default function() {
  return {
    filterRegistry: [],
    customFilterRegistry: [],
    appliedFilters: [],
    lockedFilters: [],
    filterData: [],
  };
}
